import { render, staticRenderFns } from "./CampaignShowModal.vue?vue&type=template&id=f83793d0"
import script from "./CampaignShowModal.vue?vue&type=script&lang=js"
export * from "./CampaignShowModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignShowModal.vue?vue&type=style&index=0&id=f83793d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports